import AnalyticsItemModelBase from '../_generated/modelBases/analytics-item-model-base';

export default class AnalyticsItemModel extends AnalyticsItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
